
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectAccessToken } from '../modules/login';
import { selectUserProfile, FACILITY_USERTYPE, ORG_USERTYPE, ORG_STAFF_USERTYPE, SUPERADMIN_USERTYPE } from '../modules/user';

const PublicRoute: React.FC = () => {
  const accessToken = useSelector(selectAccessToken);
  const location = useLocation();
  const userProfile = useSelector(selectUserProfile);


  if (accessToken && (location.pathname.startsWith('/facility/signup') || location.pathname === '/contact')) {
    return <Outlet />;
  }


  if(accessToken && userProfile.data?.user_type){
    switch (userProfile.data?.user_type) {
      case FACILITY_USERTYPE:
        return <Navigate to="/facility-dashboard" replace />;
      case ORG_USERTYPE:
      case ORG_STAFF_USERTYPE:
        return <Navigate to="/dashboard" replace />;
      case SUPERADMIN_USERTYPE:
        return <Navigate to="/dashboard" replace />;
      default:
        return <Outlet />;
    }
  }
  
  return <Outlet />
};

export default PublicRoute;
